/// <reference path="../../../../../../node_modules/@types/gtag.js/index.d.ts" />
import { Component } from ".././base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

export class WindowLoadEventTracker extends Component {

    private category: string | undefined;
    private action: string | undefined;
    private label: string | undefined;

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
        this.category = this._element.dataset.category;
        this.action = this._element.dataset.action;
        this.label = this._element.dataset.label;
    }

    public async init(): Promise<void> {
        // context of "this" is taken over inside jQuery function
        var thisPreserved = this;
        if(!this.category || !this.action || !this.label){
            return
        }
        $(window).on('load',function () {
            setTimeout(function () {
              var eventparams = {
                'event_category': thisPreserved.category,
                'event_action': thisPreserved.action,
                'event_label': thisPreserved.label,
                'non_interaction': true,
                'value': 0
              };
              if (typeof (gtag) !== "undefined" && eventparams.event_action) {
                gtag('event', eventparams.event_action, eventparams);
              }
            }, 3000);
          });
    }

}

ComponentFactory.registerComponent("WindowLoadEventTracker", WindowLoadEventTracker);
